import OptionsValidator from "./validators/OptionsValidator";
import FormField from "./FormField";

export default class OptionField extends FormField {
    constructor(options, isOptional = false, feature = undefined, initialValue = undefined, allowFreeText = false) {
        super(isOptional, initialValue, feature);
        this._allowFreeText = allowFreeText;
        this.updateOptions(options)
    }

    validators() {
        return this._validators
    }

    selectedValue(value) {
        super.updateValue(value)
        if (this._feature) {
            this._feature.updateFormOptions?.()
        }
    }

    updateOptions(options) {
        if (!this._allowFreeText) {
            this._validators = [new OptionsValidator(options)];
        } else {
            this._validators = [];
        }

        if (options.length === 1 && !this._allowFreeText) {
            super.updateValue(options[0]);
        }
    }
}
